import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../mobile.css';

const MobileAboutUs = () => {
  const navigate = useNavigate();

  return (
    <div style={{ background: '#000', color: '#fff', padding: '20px', margin: '-15px', minHeight: 'calc(100vh - 200px)' }}>
      <h2 style={{ fontSize: '20px', fontWeight: 'bold', marginTop: '20px', marginBottom: '15px' }}>About Us</h2>
      <p style={{ fontSize: '16px', textAlign: 'justify', marginBottom: '30px' }}>
        We are a team of Lawyers and Tech Experts. Our goal is to secure justice, strengthen legal advocacy, and ensure faster case resolution.
      </p>

      <h2 style={{ fontSize: '20px', fontWeight: 'bold', marginBottom: '15px' }}>What Our App Offers</h2>
      <p style={{ fontSize: '16px', textAlign: 'justify', marginBottom: '10px' }}>
        Our current version supports legal research for Matrimonial FIRs under Indian laws, providing:
      </p>
      <p style={{ fontSize: '16px', marginLeft: '10px', marginBottom: '15px' }}>• Detailed Analysis of Allegations</p>
      <p style={{ fontSize: '16px', marginLeft: '10px', marginBottom: '15px' }}>• Legal Rights and Remedies</p>
      <p style={{ fontSize: '16px', marginLeft: '10px', marginBottom: '15px' }}>• Fair Investigation Points</p>
      <p style={{ fontSize: '16px', marginLeft: '10px', marginBottom: '15px' }}>• Evidence Mapping</p>
      <p style={{ fontSize: '16px', marginLeft: '10px', marginBottom: '15px' }}>• Effective Legal Strategies</p>

      <p style={{ fontSize: '20px', fontWeight: 600, marginBottom: '30px' }}>Sign up to view a real FIR analysis.</p>

      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <button
          onClick={() => navigate('/m/login')}
          className="m-pill-btn"
          style={{ color: '#007AFF', fontSize: '20px', fontWeight: 600, gap: '5px' }}
        >
          Continue <span>→</span>
        </button>
      </div>
    </div>
  );
};

export default MobileAboutUs;
